import { Component, OnInit, Inject } from '@angular/core';

import { Group } from './../../shared/models/group.model';
import { RecallListService } from './recall-list.service';

@Component({
  selector: 'recall-list',
  styles: [require('./recall-list.component.scss')],
  template: require('./recall-list.component.html'),
})
export class RecallListComponent implements OnInit{
  recallList = [];
  groupId: number;

  constructor(
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
    public recallListService: RecallListService,
    ) {};

    ngOnInit() {
      this.groupId = this.$ngRedux.getState().group.id;
      this.recallListService.get(this.groupId).subscribe(
        (data) => {
          this.recallList = data;
        },
        err => undefined,
      );
    }

    bookAppointment(recall) {
      this.$state.go('patients.id.reasons.id.availabilities', { reasonId: recall.reasons[0].id, offeringId: recall.reasons[0].offering.id });
    }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/recall-list/recall-list.component.ts